// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3kW6u","row":"ProcedureTreatmentSummary_row__1AhbA"};